import { useInitialization } from '@izettle/react';
import { loadScript } from '../load-script.js';
import { jsx } from 'react/jsx-runtime';
import { shouldLoadWebComponent } from '../utils/rest.js';

const Footer = _ref => {
  let {
    locale,
    onLoaded,
    version = "latest",
    links
  } = _ref;
  useInitialization(async () => {
    if (!shouldLoadWebComponent("iz-bo-footer")) {
      return onLoaded?.();
    }
    await loadScript(`https://cdn.izettle.com/components/footer/${version}/footer.${locale}.min.js`);
    onLoaded?.();
  }, locale);
  if (!locale) {
    return null;
  }
  return /*#__PURE__*/jsx("iz-bo-footer", {
    "data-testid": "vertical-footer",
    "security-href": links?.security?.(locale),
    "legal-href": links?.legal?.(locale),
    "privacy-href": links?.privacy?.(locale),
    "cookie-href": links?.cookie?.(locale)
  });
};

export { Footer };
//# sourceMappingURL=footer.js.map
